import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "document",
  listKey: "documents",
  itemKey: "document",
  getAll: types.GET_ALL_DOCUMENTS,
  getAllResponse: types.GET_ALL_DOCUMENTS_RESPONSE,
  getByIdResponse: types.GET_DOCUMENT_BY_ID_RESPONSE,
});
